// Lets a page intercept the browser's Back and Forward buttons before Turbo does. Chrome runs window popstate
// listeners in the order they were added, capture or not, so this module is imported ahead of Turbo to register
// first. A guard returns true when it handled the event; the first one to do so stops the rest and Turbo.
const guards = new Set();

window.addEventListener("popstate", (event) => {
  for (const guard of guards) {
    if (guard(event)) {
      event.stopImmediatePropagation();
      return;
    }
  }
});

export function addBackGuard(guard) {
  guards.add(guard);
  return () => guards.delete(guard);
}
